import React, { useState } from "react";
import "../../Styles/ThallikiVandanamTable.css";
import { useNavigate } from "react-router-dom";
import {
  FaUserFriends,
  FaCheckCircle,
  FaRegClock,
  FaRupeeSign,
  FaSearch,
  FaMapMarkerAlt,
  FaFilter,
  FaSyncAlt,
  FaUserCircle,
  FaCalendarAlt,
  FaEdit,
  FaChevronLeft,
  FaChevronRight,
  FaTimes,
  FaHandHoldingHeart,
} from "react-icons/fa";

const INITIAL_DATA = [
  {
    id: 1,
    motherName: "Konda Lakshmi",
    studentName: "Konda Sai Teja",
    school: "ZP High School, Kandukur",
    className: "8th Class",
    amount: "₹15,000",
    village: "Gudluru",
    mandal: "Gudluru",
    date: "10-06-2026",
    status: "Approved",
  },
  {
    id: 2,
    motherName: "Bathula Anjamma",
    studentName: "Bathula Naveen",
    school: "MPP School, Ulavapadu",
    className: "5th Class",
    amount: "₹15,000",
    village: "Ulavapadu",
    mandal: "Ulavapadu",
    date: "22-05-2026",
    status: "Pending",
  },
  {
    id: 3,
    motherName: "Chittibomma Ratnamma",
    studentName: "Chittibomma Harika",
    school: "ZP Girls High School, Kandukur",
    className: "10th Class",
    amount: "₹15,000",
    village: "Kandukur",
    mandal: "Kandukur",
    date: "02-03-2026",
    status: "Approved",
  },
];

const AdminThallikiVandanamTable = () => {
  const navigate = useNavigate();

  const [thallikiData, setThallikiData] = useState(INITIAL_DATA);

  const [searchTerm, setSearchTerm] = useState("");
  const [mandalFilter, setMandalFilter] = useState("All Mandals");
  const [statusFilter, setStatusFilter] = useState("All Status");
  const [currentPage, setCurrentPage] = useState(1);

  const [editItem, setEditItem] = useState(null);
  const [editForm, setEditForm] = useState(null);

  /* ===================== SEARCH + FILTER LOGIC ===================== */

  const filteredData = thallikiData.filter((item) => {
    const matchesSearch =
      searchTerm.trim() === "" ||
      item.motherName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.studentName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.school.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesMandal =
      mandalFilter === "All Mandals" || item.mandal === mandalFilter;

    const matchesStatus =
      statusFilter === "All Status" || item.status === statusFilter;

    return matchesSearch && matchesMandal && matchesStatus;
  });

  const handleResetFilters = () => {
    setSearchTerm("");
    setMandalFilter("All Mandals");
    setStatusFilter("All Status");
    setCurrentPage(1);
  };

  const totalEntries = filteredData.length;
  const totalPages = Math.max(1, Math.ceil(totalEntries / 10));
  const safePage = Math.min(currentPage, totalPages);
  const startIndex = (safePage - 1) * 10;
  const endIndex = startIndex + 10;
  const pageData = filteredData.slice(startIndex, endIndex);

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  /* ===================== EDIT LOGIC ===================== */

  const openEditModal = (item) => {
    setEditItem(item);
    setEditForm({ ...item });
  };

  const closeEditModal = () => {
    setEditItem(null);
    setEditForm(null);
  };

  const handleEditChange = (field, value) => {
    setEditForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleEditSave = (e) => {
    e.preventDefault();
    setThallikiData((prev) =>
      prev.map((item) => (item.id === editForm.id ? { ...editForm } : item)),
    );
    closeEditModal();
  };

  return (
    <div className="tv-page">
      {/* ── FIXED HEADER ── */}
      <div className="tv-header">
        <div className="tv-header-left">
          <div className="tv-header-icon">
            <FaHandHoldingHeart />
          </div>
          <div>
            <h2 className="tv-title">Thalliki Vandanam Beneficiaries</h2>
            <p className="tv-subtitle">
              Manage and track beneficiaries under Thalliki Vandanam scheme
            </p>
          </div>
        </div>

        <button
          className="tv-add-btn"
          onClick={() => navigate("/AdminDashboard/ThallikiVandanamForm")}
        >
          <span className="tv-add-plus">+</span> Add New Beneficiary
        </button>
      </div>

      {/* ── SCROLLABLE BODY ── */}
      <div className="tv-scroll-body">
        {/* Stat Cards */}
        <div className="tv-stats-row">
          <div className="tv-stat-card">
            <div className="tv-stat-icon tv-icon-purple">
              <FaUserFriends />
            </div>
            <div>
              <p className="tv-stat-label">Total Beneficiaries</p>
              <h3 className="tv-stat-value">1,256</h3>
              <p className="tv-stat-sub">All time records</p>
            </div>
          </div>

          <div className="tv-stat-card">
            <div className="tv-stat-icon tv-icon-green">
              <FaCheckCircle />
            </div>
            <div>
              <p className="tv-stat-label">Approved Beneficiaries</p>
              <h3 className="tv-stat-value">985</h3>
              <p className="tv-stat-sub tv-sub-green">78.4% of total</p>
            </div>
          </div>

          <div className="tv-stat-card">
            <div className="tv-stat-icon tv-icon-orange">
              <FaRegClock />
            </div>
            <div>
              <p className="tv-stat-label">Pending Beneficiaries</p>
              <h3 className="tv-stat-value">271</h3>
              <p className="tv-stat-sub tv-sub-orange">21.6% of total</p>
            </div>
          </div>

          <div className="tv-stat-card">
            <div className="tv-stat-icon tv-icon-purple2">
              <FaRupeeSign />
            </div>
            <div>
              <p className="tv-stat-label">Total Amount Disbursed</p>
              <h3 className="tv-stat-value">₹1,88,40,000</h3>
              <p className="tv-stat-sub tv-sub-purple">All time disbursed</p>
            </div>
          </div>
        </div>

        {/* Filter Section */}
        <div className="tv-filter-section">
          <div className="tv-search-wrapper">
            <FaSearch className="tv-search-icon" />
            <input
              type="text"
              placeholder="Search Beneficiary..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
            />
          </div>

          <div className="tv-select-wrapper">
            <FaMapMarkerAlt className="tv-select-icon" />
            <select
              value={mandalFilter}
              onChange={(e) => {
                setMandalFilter(e.target.value);
                setCurrentPage(1);
              }}
            >
              <option>All Mandals</option>
              <option>Kandukur</option>
              <option>Gudluru</option>
              <option>Ulavapadu</option>
            </select>
          </div>

          <div className="tv-select-wrapper">
            <FaFilter className="tv-select-icon" />
            <select
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e.target.value);
                setCurrentPage(1);
              }}
            >
              <option>All Status</option>
              <option>Approved</option>
              <option>Pending</option>
            </select>
          </div>

          <button className="tv-reset-btn" onClick={handleResetFilters}>
            <FaSyncAlt /> Reset Filters
          </button>
        </div>

        {/* Table */}
        <div className="tv-table-wrapper">
          <table className="tv-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Mother's Name</th>
                <th>Student Name</th>
                <th>School</th>
                <th>Class</th>
                <th>Amount</th>
                <th>Village</th>
                <th>Mandal</th>
                <th>Date</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {pageData.length > 0 ? (
                pageData.map((item, index) => (
                  <tr key={item.id}>
                    <td>{startIndex + index + 1}</td>
                    <td>
                      <div className="tv-name-cell">
                        <span className="tv-avatar">
                          <FaUserCircle />
                        </span>
                        <span className="tv-name-text">
                          {item.motherName}
                        </span>
                      </div>
                    </td>
                    <td className="tv-student-cell">{item.studentName}</td>
                    <td className="tv-school-cell">{item.school}</td>
                    <td>
                      <span className="tv-class-pill">{item.className}</span>
                    </td>
                    <td className="tv-amount">{item.amount}</td>
                    <td>
                      <span className="tv-village-cell">
                        <FaMapMarkerAlt /> {item.village}
                      </span>
                    </td>
                    <td>{item.mandal}</td>
                    <td>
                      <span className="tv-date-cell">
                        <FaCalendarAlt /> {item.date}
                      </span>
                    </td>
                    <td>
                      <span
                        className={`tv-status ${
                          item.status === "Approved"
                            ? "tv-approved"
                            : "tv-pending"
                        }`}
                      >
                        {item.status === "Approved" ? (
                          <FaCheckCircle />
                        ) : (
                          <FaRegClock />
                        )}{" "}
                        {item.status}
                      </span>
                    </td>
                    <td className="tv-action-cell">
                      <button
                        className="tv-edit-btn"
                        onClick={() => openEditModal(item)}
                      >
                        <FaEdit /> Edit
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="tv-no-data">
                    No matching beneficiaries found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Footer / Pagination */}
        <div className="tv-footer">
          <p className="tv-footer-text">
            {totalEntries > 0
              ? `Showing ${startIndex + 1} to ${Math.min(
                  endIndex,
                  totalEntries,
                )} of ${totalEntries} beneficiaries`
              : "Showing 0 beneficiaries"}
          </p>

          <div className="tv-pagination">
            <button
              className="tv-page-btn"
              onClick={() => goToPage(safePage - 1)}
              disabled={safePage === 1}
            >
              <FaChevronLeft />
            </button>

            {Array.from({ length: totalPages }, (_, i) => i + 1).map(
              (page) => (
                <button
                  key={page}
                  className={`tv-page-btn ${
                    safePage === page ? "tv-page-active" : ""
                  }`}
                  onClick={() => goToPage(page)}
                >
                  {page}
                </button>
              ),
            )}

            <button
              className="tv-page-btn"
              onClick={() => goToPage(safePage + 1)}
              disabled={safePage === totalPages}
            >
              <FaChevronRight />
            </button>
          </div>
        </div>

        {/* Scheme Info Banner */}
        <div className="tv-scheme-banner">
          <div className="tv-banner-icon-left">
            <FaHandHoldingHeart />
          </div>

          <div className="tv-banner-text">
            <h4>Thalliki Vandanam Scheme</h4>
            <p>
              Financial assistance of ₹15,000 is provided to eligible mothers
              for the education and welfare of their children.
            </p>
          </div>
        </div>
      </div>

      {/* ===================== EDIT MODAL ===================== */}
      {editItem && editForm && (
        <div className="tv-modal-overlay" onClick={closeEditModal}>
          <div
            className="tv-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="tv-modal-header">
              <h3>Edit Beneficiary</h3>
              <button className="tv-modal-close" onClick={closeEditModal}>
                <FaTimes />
              </button>
            </div>

            <form className="tv-modal-form" onSubmit={handleEditSave}>
              <div className="tv-form-row">
                <label>Mother's Name</label>
                <input
                  type="text"
                  value={editForm.motherName}
                  onChange={(e) =>
                    handleEditChange("motherName", e.target.value)
                  }
                  required
                />
              </div>

              <div className="tv-form-row">
                <label>Student Name</label>
                <input
                  type="text"
                  value={editForm.studentName}
                  onChange={(e) =>
                    handleEditChange("studentName", e.target.value)
                  }
                  required
                />
              </div>

              <div className="tv-form-row">
                <label>School</label>
                <input
                  type="text"
                  value={editForm.school}
                  onChange={(e) =>
                    handleEditChange("school", e.target.value)
                  }
                  required
                />
              </div>

              <div className="tv-form-grid">
                <div className="tv-form-row">
                  <label>Class</label>
                  <input
                    type="text"
                    value={editForm.className}
                    onChange={(e) =>
                      handleEditChange("className", e.target.value)
                    }
                    required
                  />
                </div>

                <div className="tv-form-row">
                  <label>Amount</label>
                  <input
                    type="text"
                    value={editForm.amount}
                    onChange={(e) =>
                      handleEditChange("amount", e.target.value)
                    }
                    required
                  />
                </div>
              </div>

              <div className="tv-form-grid">
                <div className="tv-form-row">
                  <label>Village</label>
                  <input
                    type="text"
                    value={editForm.village}
                    onChange={(e) =>
                      handleEditChange("village", e.target.value)
                    }
                    required
                  />
                </div>

                <div className="tv-form-row">
                  <label>Mandal</label>
                  <select
                    value={editForm.mandal}
                    onChange={(e) =>
                      handleEditChange("mandal", e.target.value)
                    }
                  >
                    <option>Kandukur</option>
                    <option>Gudluru</option>
                    <option>Ulavapadu</option>
                  </select>
                </div>
              </div>

              <div className="tv-form-grid">
                <div className="tv-form-row">
                  <label>Date</label>
                  <input
                    type="text"
                    placeholder="DD-MM-YYYY"
                    value={editForm.date}
                    onChange={(e) =>
                      handleEditChange("date", e.target.value)
                    }
                    required
                  />
                </div>

                <div className="tv-form-row">
                  <label>Status</label>
                  <select
                    value={editForm.status}
                    onChange={(e) =>
                      handleEditChange("status", e.target.value)
                    }
                  >
                    <option>Approved</option>
                    <option>Pending</option>
                  </select>
                </div>
              </div>

              <div className="tv-modal-actions">
                <button
                  type="button"
                  className="tv-modal-cancel-btn"
                  onClick={closeEditModal}
                >
                  Cancel
                </button>
                <button type="submit" className="tv-modal-save-btn">
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminThallikiVandanamTable;